import { lazy, LazyExoticComponent } from 'react'

export type TRouteConfig = {
    path: string
    auth: boolean
    component: LazyExoticComponent<any>
    name?:string
}

const routeConfig: TRouteConfig[] = [
    {
        path: '/',
        auth: false,
        component: lazy(() => import('@/pages/Home')),
        name: 'home'
    },
    {
        path: '/home',
        auth: false,
        component: lazy(() => import('@/pages/Home')),
        name: 'home'
    },
    {
        // iOS_v1.6开始使用新的机器人页面
        path: '/robot',
        auth: false,
        component: lazy(() => import('@/pages/Robot')),
        name: 'robot'
    },
    {
        // iOS_v1.5之前使用的机器人页面
        path: '/im',
        auth: false,
        component: lazy(() => import('@/pages/IM')),
        name: 'im'
    },
    {
        path: '/im/quick-file-picker',
        auth: false,
        component: lazy(() => import('@/pages/IM/QuickBTFilePicker')),
        name: 'quickBTFilePicker'
    },
    {
        path: '/services',
        auth: false,
        component: lazy(() => import('@/pages/ServicePage')),
        name: 'services'
    },
    {
        // iOS_v1.7.4之后的服务升级页面
        path: '/v1.7.4/services',
        auth: false,
        component: lazy(() => import('@/pages/ServicePage/v2.index')),
        name: 'service-settings'
    },
    {
        path: '/service-settings',
        auth: false,
        component: lazy(() => import('@/pages/ServiceSetting')),
        name: 'service-settings'
    },
    {
        // iOS_v1.7.4之后的服务设置页面
        path: '/v1.7.4/service-settings',
        auth: false,
        component: lazy(() => import('@/pages/ServiceSetting/v2.index')),
        name: 'service-settings'
    },
    {
        path: '/task',
        auth: false,
        component: lazy(() => import('@/pages/TaskManager')),
        name: 'task'
    },
    {
        path: '/task/:type',
        auth: false,
        // component: lazy(() => import('@/pages/TaskManager/Task')),
        component: lazy(() => import('@/pages/TaskManager')),
        name: 'task-info'
    },
    {
        path: '/help',
        auth: false,
        component: lazy(() => import('@/pages/Help')),
        name: 'help'
    },
    {
        path: '/help/:qid',
        auth: false,
        component: lazy(() => import('@/pages/Help')),
        name: 'question'
    },
    {
        path: '/member/activate',
        auth: false,
        component: lazy(() => import('@/pages/Member')),
        name: 'memberActivate'
    },
    {
        path: '/member/upgrade',
        auth: false,
        component: lazy(() => import('@/pages/Member/Upgrade')),
        name: 'memberUpgrade'
    },
    {
        path: '/member/payment',
        auth: false,
        component: lazy(() => import('@/pages/Member/Payment')),
        name: 'memberUpgrade'
    },
    {
        path: '/policy/privacy',
        auth: false,
        component: lazy(() => import('@/pages/Policy/Privacy')),
        name: 'privacyPolicy'
    },
    {
        path: '/policy/sdk-permission',
        auth: false,
        component: lazy(() => import('@/pages/Policy/Privacy/SDKPermissionDesc')),
        name: 'SDKPermissionDesc'
    },
    {
        path: '/policy/personal-information-collection-list',
        auth: false,
        component: lazy(() => import('@/pages/Policy/Privacy/PersonalInformationCollectionList')),
        name: 'PersonalInformationCollectionList'
    },
    {
        path: '/bittorrent-fetch',
        auth: false,
        component: lazy(() => import('@/pages/BittorrentFetch')),
        name: 'bittorrentFetch'
    },
    {
        path: '*',
        auth: false,
        component: lazy(() => import('@/pages/Error/NotFound'))
    }
]

export default routeConfig
